import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Helmet } from "react-helmet-async";
import type { User } from "@wishlist-hub/shared";
import { Button, Card, ErrorText, Input, Label } from "../components/ui";
import { api } from "../services/api";
import { useAuthStore } from "../stores/authStore";

const schema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});

export function Login() {
  const nav = useNavigate();
  const setUser = useAuthStore((s) => s.setUser);
  const [err, setErr] = useState("");
  const f = useForm<z.infer<typeof schema>>({ resolver: zodResolver(schema) });

  const onSubmit = f.handleSubmit(async (v) => {
    setErr("");
    try {
      const { data } = await api.post<{ user: User }>("/auth/login", v);
      setUser(data.user);
      nav("/profile");
    } catch {
      setErr("Неверный email или пароль");
    }
  });

  return (
    <>
      <Helmet>
        <title>Вход — WishList Hub</title>
      </Helmet>
      <Card className="max-w-md mx-auto">
        <h1 className="text-xl font-semibold text-white">Вход</h1>
        <form className="mt-4 space-y-3" onSubmit={onSubmit}>
          <div>
            <Label>Email</Label>
            <Input type="email" autoComplete="email" {...f.register("email")} />
          </div>
          <div>
            <Label>Пароль</Label>
            <Input type="password" autoComplete="current-password" {...f.register("password")} />
          </div>
          {err && <ErrorText>{err}</ErrorText>}
          <Button type="submit" className="w-full" disabled={f.formState.isSubmitting}>
            Войти
          </Button>
        </form>
        <p className="mt-4 text-center text-sm text-slate-500">
          Нет аккаунта? <Link to="/auth/register" className="text-violet-400">Регистрация</Link>
        </p>
      </Card>
    </>
  );
}
